export const BREAKPOINTS = {
  xs: "620px",
  sm: "768px",
  md: "1024px",
  lg: "1280px",
  xl: "1440px",
  "2xl": "1680px",
} as const;

export type BreakpointsType = keyof typeof BREAKPOINTS;
